import { CurriculumTabForm } from './types'

export const INITIAL_VALUES: CurriculumTabForm = {
  descricao: '',
  curriculo_doc: undefined,
}
